import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { HeaderComponent } from '../header/header.component';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,   private router: Router,
    private header: HeaderComponent,) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (!this.authService.isAuthenticated()) {
   //   this.router.navigate(['buy']);
   this.header.loginDialog(); 
   return false;
    }
    return true;
  }
}
